import moment from "moment";
import 'moment/locale/vi';

const NotificationItem = ({ noti, onClick, onAcceptFriend, onRejectFriend }) => {
    const getAvatarSrc = (actor) => {
        if (!actor?.profilePic) {
            return "/public/noAvatar.png";
        }

        return actor.profilePic.startsWith("http") 
            ? actor.profilePic 
            : "/upload/" + actor.profilePic
    };

    const renderContent = () => {
        switch (noti.type) {
            case 'LIKE':
                return <span>liked your post.</span>;
            case 'COMMENT':
                return <span>commented on your post</span>;
            case 'REPLY':
                return <span>replied to your comment.</span>;
            case 'FRIEND_REQUEST':
                return (
                    <div className="friend-request-box">
                        <span>{noti.message}</span>
                        <div className="action-buttons">
                            <button 
                                className="btn-accept"
                                onClick={(e) => { e.stopPropagation(); onAcceptFriend(noti); }}
                            >
                                Confirm
                            </button>

                            <button 
                                className="btn-reject"
                                onClick={(e) => { e.stopPropagation(); onRejectFriend(noti); }}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                );
            default:
                return <span>{noti.message}</span>;
        }
    };

    return (
        <div 
            className={`userNotification ${!noti.isRead ? 'unread' : ''}`}
            onClick={() => onClick(noti)}
        >
            <img 
                src={getAvatarSrc(noti.actorId)}
                alt="" 
                onError={(e) => { e.target.src = "/public/noAvatar.png"; }}
            />

            <div className="info">
                <p>
                    <span className="userName">
                        {noti.actorId?.username || "Hidden user"}
                    </span>
                    
                    <span className="content"> 
                        {/* {noti.message} */}
                        {renderContent()}
                    </span>
                </p>

                <span className="date">
                    {moment(noti.createdAt).fromNow()}
                </span>
            </div>
        </div>
    );
};

export default NotificationItem;